import React from 'react';
import { Button, CardMedia, Grid, Step, StepContent, StepLabel, Stepper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TourOneListItem from './TourOneListItem';
import { Box } from '@mui/system';
import TourDateList from '../../tour-date/TourDateList';
import TourService from '../../../../../services/TourService';

interface TourOneTabViewProps {
}

var service = new TourService();
const TourOneTabView: React.FC<TourOneTabViewProps> = ({ }) => {
    const { t } = useTranslation();

    const tour = service.tours.find(t => t.id === 1);

    if (tour === undefined) {
        return null;
    }

    return (
        <Grid>
            <Box
                sx={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/images/background/${1}.jpg)`,
                    backgroundPosition: "center",
                    backgroundSize: "cover"
                }}
                mb={4}
                pl={0}
                pr={0}
                width={"100vw"}
                marginLeft={"calc(50% - 50vw)"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}>
                <Grid
                    p={2}
                    pt={6}
                    pb={6}
                    container
                    justifyContent={"center"}
                    sx={{
                        backdropFilter: "blur(0px)",
                        backgroundColor: "#9191919f"
                    }}>
                    <Box maxWidth={400} width={"100%"}>
                        <TourOneListItem tour={tour} showDetails />
                    </Box>
                </Grid>
            </Box>

            <Box mt={6} display={"flex"} flexDirection={"column"} width={"100%"} alignItems={"center"} justifyContent={"center"}>
                <Typography variant='h5' fontWeight={600} mb={4}>{t("tour.reserveYourRide")}</Typography>
            </Box>
            <TourDateList tour={tour} />
        </Grid>
    )
}

export default TourOneTabView;